export default __webpack_public_path__ + "static/media/mc_cv_1.92edf770.jpg";